import { Plane, Globe2, Map, Ruler, PanelLeftOpen } from 'lucide-react';
import type { FlightStats } from '@/types';
import { formatNumber, formatDistance } from '@/utils';

interface StatsDisplayProps {
  stats: FlightStats;
  showMobilePanels?: boolean;
  onToggleMobilePanels?: () => void;
  viewingFriend?: boolean;
}

export function StatsDisplay({ stats, showMobilePanels, onToggleMobilePanels, viewingFriend }: StatsDisplayProps) {
  const statItems = [
    {
      icon: Plane,
      value: stats.totalFlights,
      label: 'Flights',
      color: 'text-primary-500',
    },
    {
      icon: Globe2,
      value: stats.uniqueCountries,
      label: 'Countries',
      color: 'text-pink-400',
    },
    {
      icon: Ruler,
      value: formatDistance(stats.totalMiles),
      label: 'Miles',
      color: 'text-green-400',
    },
    {
      icon: Map,
      value: stats.uniqueAirports,
      label: 'Airports',
      color: 'text-yellow-400',
    },
  ];

  return (
    <div className="flex flex-wrap gap-2 md:gap-4">
      {/* Mobile Panel Toggle Button - only show when panels can be toggled */}
      {!viewingFriend && onToggleMobilePanels && !showMobilePanels && (
        <button
          onClick={onToggleMobilePanels}
          className="md:hidden glass rounded-lg md:rounded-xl p-2 md:p-4 flex-1 min-w-[70px] md:min-w-[120px] text-center hover:scale-105 transition-transform"
          title="Show panels"
        >
          <PanelLeftOpen className="w-4 h-4 md:w-5 md:h-5 mx-auto mb-1 md:mb-2 text-primary-500" />
          <div className="text-[10px] md:text-xs text-white/60 uppercase tracking-wider mt-0.5 md:mt-1">
            Manage Flights
          </div>
        </button>
      )}
      
      {statItems.map((item) => (
        <div
          key={item.label}
          className="glass rounded-lg md:rounded-xl p-2 md:p-4 flex-1 min-w-[70px] md:min-w-[120px] text-center hover:scale-105 transition-transform"
        >
          <item.icon className={`w-4 h-4 md:w-5 md:h-5 mx-auto mb-1 md:mb-2 ${item.color}`} />
          <div className={`text-base md:text-2xl font-bold ${item.color} glow-blue`}>
            {typeof item.value === 'number'
              ? formatNumber(item.value)
              : item.value}
          </div>
          <div className="text-[10px] md:text-xs text-white/60 uppercase tracking-wider mt-0.5 md:mt-1">
            {item.label}
          </div>
        </div>
      ))}
    </div>
  );
}
